/** 表サイトカレンダー：佳／メ文字の代わりに佳林スタンプ画像 */

/** public/ を差し替えたら数字を上げる（ブラウザキャッシュ回避） */
const STAMP_ASSET_VER = "3";
const STAMP_ONLINE_SRC = `/karin-stamp-online.png?v=${STAMP_ASSET_VER}`;
const STAMP_LIVE_SRC = `/karin-stamp-live.png?v=${STAMP_ASSET_VER}`;

type Props = {
  isRemote: boolean;
  icon?: string | null;
  title?: string;
  className?: string;
};

export function KarinCalendarStamp({ isRemote, icon, title, className = "" }: Props) {
  const customIcon = typeof icon === "string" && icon.trim() ? icon.trim() : "";
  const forcedFace = customIcon === "face_live" ? "live" : customIcon === "face_online" ? "online" : null;
  if (forcedFace) {
    const src = forcedFace === "online" ? STAMP_ONLINE_SRC : STAMP_LIVE_SRC;
    const alt = forcedFace === "online" ? "宮本佳林（オンライン）" : "宮本佳林（直接会える）";
    return (
      <img
        src={src}
        alt={alt}
        title={title ?? alt}
        className={`stamp-karin-img${forcedFace === "online" ? " stamp-karin-img--online" : " stamp-karin-img--live"}${className ? ` ${className}` : ""}`}
        height={34}
        width={38}
        loading="lazy"
        decoding="async"
      />
    );
  }
  if (customIcon) {
    return (
      <span
        role="img"
        aria-label={title ?? "宮本佳林の予定"}
        title={title ?? "宮本佳林の予定"}
        className={`stamp-karin-img stamp-karin-emoji${isRemote ? " stamp-karin-img--online" : " stamp-karin-img--live"}${className ? ` ${className}` : ""}`}
      >
        {customIcon}
      </span>
    );
  }
  const src = isRemote ? STAMP_ONLINE_SRC : STAMP_LIVE_SRC;
  const alt = isRemote ? "宮本佳林（オンライン）" : "宮本佳林（直接会える）";
  return (
    <img
      src={src}
      alt={alt}
      title={title ?? alt}
      className={`stamp-karin-img${isRemote ? " stamp-karin-img--online" : " stamp-karin-img--live"}${className ? ` ${className}` : ""}`}
      height={34}
      width={38}
      loading="lazy"
      decoding="async"
    />
  );
}

/** 凡例用の小さなプレビュー */
export function KarinCalendarStampLegend({ isRemote }: { isRemote: boolean }) {
  return <KarinCalendarStamp isRemote={isRemote} className="stamp-karin-img--legend" />;
}
